import Check from "@mui/icons-material/Check";

import styles from "./style.module.scss";

interface ContractTypeCheckboxProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
}

const ContractTypeCheckbox = ({ id, label, checked, onChange, disabled = false }: ContractTypeCheckboxProps) => {
    return (
        <div className={styles["checkbox-container"]}>
            <button
                type="button"
                role="checkbox"
                aria-checked={checked}
                id={id}
                className={`${styles["checkbox"]} ${checked ? styles["checked"] : ""}`}
                onClick={disabled ? undefined : onChange}
                disabled={disabled}
            >
                <span className={styles["check-wrapper"]}>{checked && <Check className={styles["check-icon"]} />}</span>
            </button>
            <label htmlFor={id} className={styles["label"]} onClick={disabled ? undefined : onChange}>
                {label}
            </label>
        </div>
    );
};

export default ContractTypeCheckbox;
